module.exports = __webpack_public_path__ + "img/pixsell.bd0adef8.svg";